import ToolbarPluginSwitchboard from "csi/view/ToolbarPluginSwitchboard";
import Query from "csi/xml/Query";
import declare from "dojo/_base/declare";
import ProductType from "../ProductType";

const ColorPaletteSwitchboard = declare(ToolbarPluginSwitchboard, {
	disableButtonAction: true,
	idViewProperty: "selectedPalette",
	resDefault: "SelectOne",
	refreshStoreOptions: true,
	hideGo: true,
	actionToolbar: null,

	// boolean: set to true if the color rule is enforced for the product node on the view
	isColorRuleEnforced: false,

	/**
	 * @override
	 * Set view node based on the color rule.
	 */
	onChangeItem: function (view, node) {
		if (!view) {
			return;
		}
		if (this.isColorRuleEnforced) {
			view.setViewNode(node);
		}
	},

	/**
	 * @override
	 * Add query filters to get the palettes with matched style hierarchy.
	 */
	_getStoreOptions(url, r) {
		const view = this.actionToolbar.view;
		const cache = view.cacheView;
		const style = cache.getNode(view.productUrl);
		this.isColorRuleEnforced = ProductType.getColorRule(style) === "ColorPaletteRuleTypes:Enforced";
		const query = new Query();
		ProductType.applyStyleHierarchyFilters(style, query, cache);
		r.m_query = query;
		return this.inherited(arguments);
	},
});

export = ColorPaletteSwitchboard;